var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"top-title-container"},[_c('div',{staticClass:"top-title"},[_c('div',{staticClass:"top-title-left"},[_vm._t("left")],2),_c('div',{staticClass:"top-title-center"},[_vm._t("center")],2),_c('div',{staticClass:"top-title-right"},[_vm._t("right")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }